module.exports = __webpack_public_path__ + "3ed364a667e8b157c92c6e242062dc1c.png";